import React from "react";
import { DeepMap, FieldError, FieldValues } from "react-hook-form";

export type RadioOption = {
  id: string;
  label: string;
  value: string;
  disabled?: boolean;
};

type RadioLayout = "inline" | "stacked";

type RadioGroupInputProps = {
  name: string;
  options: RadioOption[];
  selectedValue?: string;
  onChange: (value: string) => void;
  layout?: RadioLayout;
  errors: DeepMap<FieldValues, FieldError>;
  register: any;
  isRequired?: boolean;
  t: any;
};

const RadioGroupInput: React.FC<RadioGroupInputProps> = ({
  name,
  options,
  selectedValue,
  onChange,
  layout = "inline",
  errors,
  register,
  isRequired = false,
  t,
}) => {
  const radioWrapperClass =
    layout === "inline" ? "radio-inline" : "radio-stacked";

  return (
    <div className={radioWrapperClass}>
      {options.map((option, index) => {
        const validationOptions =
          index === 0
            ? { required: isRequired && t("Please fill out this field.") }
            : {};
        return (
          <div
            className={`custom-control custom-radio ${radioWrapperClass}`}
            key={name + option.id}
          >
            <input
              type="radio"
              className={`custom-control-input mx-2
              ${errors[name] ? "is-invalid" : ""}`}
              id={name + option.id}
              name={name}
              value={option.value}
              checked={selectedValue && selectedValue === option.value}
              onChange={(e) => onChange(e.target.value)}
              disabled={option.disabled}
              ref={register}
              {...register(name, validationOptions)}
            />
            <label className="custom-control-label" htmlFor={name + option.id}>
              {option.label}
            </label>
          </div>
        );
      })}
      {errors[name] && (
        <div className="invalid-feedback d-block">{errors[name].message}</div>
      )}
    </div>
  );
};

export default RadioGroupInput;
